module.exports = __webpack_public_path__ + "media/images/sp_menu_close_icon-fae95630582dc7f866ea565fb8855382.svg";